import Store from '~store/store'

export default {
  install(Vue) {
    const sendComment = (content, objectModel, objectId, extraKey, commentId, attributes) => {
      const comment = {
        content,
        object_id: objectId,
        object_model: extraKey ? objectModel + ':' + extraKey : objectModel,
        system_log: true,
        attributes
      }

      if (commentId) {
        comment.id = commentId
      }

      return Store.dispatch('sendComment', comment)
    }

    Vue.prototype.$sendComment = Vue.sendComment = sendComment
  }
}
